import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from '../../../store/store';
import { matchOrg, verifyEmailViaLink } from '../../../features/user/utils';

const VerifyEmailViaLink: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const userState = useSelector((state: RootState) => state.user);
  const verificationAttempted = useRef(false);
  const searchParams = new URLSearchParams(location.search);
  const verifyToken = searchParams.get('token');

  useEffect(() => {
    if (verifyToken && !verificationAttempted.current) {
      verificationAttempted.current = true;
      dispatch(verifyEmailViaLink(verifyToken)).then((result) => {
        if (verifyEmailViaLink.fulfilled.match(result)) {
          dispatch(matchOrg());
          navigate('/auth/organization');
        }
      });
    }
  }, [verifyToken, dispatch]);

  if (userState.verificationFormError.requestError) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
        <Typography variant="h5" color="error" mb={2}>
          Verification Failed
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={2}>
          {userState.verificationFormError.requestError}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <a href="/auth/sign-in">Return to Sign In</a>
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
      <Typography variant="h5" mb={2}>
        Verifying your email...
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Please wait while we verify your link.
      </Typography>
    </Box>
  );
};

export default VerifyEmailViaLink;
